import { render, staticRenderFns } from "./RegistroMediaFiliacion.vue?vue&type=template&id=4fefd23d&scoped=true"
import script from "./RegistroMediaFiliacion.vue?vue&type=script&lang=js"
export * from "./RegistroMediaFiliacion.vue?vue&type=script&lang=js"
import style0 from "./RegistroMediaFiliacion.vue?vue&type=style&index=0&id=4fefd23d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fefd23d",
  null
  
)

export default component.exports